"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customClaimTypeQuery = exports.createCustomClaimTypeQueryFilters = exports.trustingAssetsQuery = exports.trustedClaimIssuerQuery = exports.claimsQuery = exports.claimsGroupingQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 *  @hidden
 */
function createClaimsFilters(variables) {
    const args = ['$size: Int, $start: Int'];
    const filters = ['revokeDate: { isNull: true }'];
    const { dids, claimTypes, trustedClaimIssuers, scope, includeExpired } = variables;
    if (dids === null || dids === void 0 ? void 0 : dids.length) {
        args.push('$dids: [String!]');
        filters.push('targetId: { in: $dids }');
    }
    if (claimTypes) {
        args.push('$claimTypes: [ClaimTypeEnum!]!');
        filters.push('type: { in: $claimTypes }');
    }
    if (trustedClaimIssuers === null || trustedClaimIssuers === void 0 ? void 0 : trustedClaimIssuers.length) {
        args.push('$trustedClaimIssuers: [String!]');
        filters.push('issuerId: { in: $trustedClaimIssuers }');
    }
    if (scope !== undefined) {
        args.push('$scope: JSON!');
        filters.push('scope: { contains: $scope }');
    }
    if (!includeExpired) {
        args.push('$expiryTimestamp: BigFloat');
        filters.push('or: [{ filterExpiry: { lessThan: $expiryTimestamp } }, { expiry: { isNull: true } }]');
    }
    return {
        args: `(${args.join()})`,
        filter: `filter: { ${filters.join()} },`,
    };
}
/**
 * @hidden
 *
 * Get all dids with at least one claim for a given scope and from one of the given trusted claim issuers
 */
function claimsGroupingQuery(variables, orderBy = types_1.ClaimsOrderBy.TargetIdAsc, groupBy = types_1.ClaimsGroupBy.TargetId) {
    const { args, filter } = createClaimsFilters(variables);
    const query = (0, graphql_tag_1.default) `
    query claimsGroupingQuery
      ${args}
     {
      claims(
        ${filter}
        orderBy: [${orderBy}]
        first: $size
        offset: $start
      ) {
        groupedAggregates(groupBy: [${groupBy}], having: {}) {
          keys
        }
      }
    }
  `;
    return {
        query,
        variables: (0, common_1.removeUndefinedValues)(variables),
    };
}
exports.claimsGroupingQuery = claimsGroupingQuery;
/**
 * @hidden
 *
 * Get all claims that a given target DID has, with a given scope and from one of the given trustedClaimIssuers
 */
function claimsQuery(paddedIds, filters, size, start) {
    const { args, filter } = createClaimsFilters(filters);
    const orderBy = paddedIds
        ? `${types_1.ClaimsOrderBy.TargetIdAsc}, ${types_1.ClaimsOrderBy.CreatedBlockIdAsc}, ${types_1.ClaimsOrderBy.EventIdxAsc}`
        : `${types_1.ClaimsOrderBy.TargetIdAsc}, ${types_1.ClaimsOrderBy.CreatedAtAsc}, ${types_1.ClaimsOrderBy.CreatedBlockIdAsc}, ${types_1.ClaimsOrderBy.EventIdxAsc}`;
    const query = (0, graphql_tag_1.default) `
    query ClaimsQuery
      ${args}
      {
        claims(
          ${filter}
          orderBy: [${orderBy}]
          first: $size
          offset: $start
        ) {
          totalCount
          nodes {
            targetId
            type
            scope
            cddId
            issuerId
            issuanceDate
            lastUpdateDate
            expiry
            jurisdiction
            customClaimTypeId
          }
        }
      }
    `;
    return {
        query,
        variables: (0, common_1.removeUndefinedValues)(Object.assign(Object.assign(Object.assign({}, filters), { expiryTimestamp: filters.includeExpired ? undefined : new Date().getTime() }), (0, common_1.getSizeAndOffset)(size, start))),
    };
}
exports.claimsQuery = claimsQuery;
/**
 * @hidden
 *
 * Get an trusted claim issuer event for an asset and an issuer
 */
function trustedClaimIssuerQuery(paddedIds, variables) {
    const orderBy = paddedIds
        ? `${types_1.TrustedClaimIssuersOrderBy.CreatedBlockIdDesc}`
        : `${types_1.TrustedClaimIssuersOrderBy.CreatedAtDesc}, ${types_1.TrustedClaimIssuersOrderBy.CreatedBlockIdDesc}`;
    const query = (0, graphql_tag_1.default) `
    query TrustedClaimIssuerQuery($assetId: String!, $issuer: String!) {
      trustedClaimIssuers(
        filter: { assetId: { equalTo: $assetId }, issuer: { equalTo: $issuer } }
        orderBy: [${orderBy}]
      ) {
        nodes {
          eventIdx
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.trustedClaimIssuerQuery = trustedClaimIssuerQuery;
/**
 * @hidden
 *
 * Get an trusted claim issuer event for an asset and an issuer
 */
function trustingAssetsQuery(variables) {
    const query = (0, graphql_tag_1.default) `
    query TrustedClaimIssuerQuery($issuer: String!) {
      trustedClaimIssuers(
        filter: { issuer: { equalTo: $issuer } },
        orderBy: [${types_1.TrustedClaimIssuersOrderBy.AssetIdAsc}]
      ) {
        nodes {
          asset {
            id
            ticker
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.trustingAssetsQuery = trustingAssetsQuery;
/**
 *  @hidden
 */
function createCustomClaimTypeQueryFilters(variables) {
    const args = ['$size: Int, $start: Int'];
    const filters = [];
    const { dids } = variables;
    if (dids === null || dids === void 0 ? void 0 : dids.length) {
        args.push('$dids: [String!]');
        filters.push('identityId: { in: $dids }');
    }
    return {
        args: `(${args.join()})`,
        filter: filters.length ? `filter: { ${filters.join()} },` : '',
    };
}
exports.createCustomClaimTypeQueryFilters = createCustomClaimTypeQueryFilters;
/**
 * @hidden
 *
 * Get registered CustomClaimTypes
 */
function customClaimTypeQuery(size, start, dids) {
    const { args, filter } = createCustomClaimTypeQueryFilters({ dids });
    const query = (0, graphql_tag_1.default) `
  query CustomClaimTypesQuery
    ${args}
    {
      customClaimTypes(
        ${filter}
        first: $size
        offset: $start
      ){
        nodes {
          id
          name
          identityId
        }
        totalCount
      }
    }
`;
    return {
        query,
        variables: (0, common_1.removeUndefinedValues)(Object.assign(Object.assign({}, (0, common_1.getSizeAndOffset)(size, start)), { dids })),
    };
}
exports.customClaimTypeQuery = customClaimTypeQuery;
//# sourceMappingURL=claims.js.map